import { createAction } from '@reduxjs/toolkit';

import { post, get } from './axios-request-actions';

import {
  CLEAR_AUTH_TOKEN,
  CLEAR_MFA_CHALLENGE,
  CLEAR_SUBMITED_SIGNED_IN_SIGNAL,
  INITIALIZE_USER_TOKEN,
  REFRESH_AUTH_TOKEN,
  SET_MFA_CHALLENGE,
  SHOW_CONFIRM_NAVIGATION_MODAL,
  SIGN_IN,
  SIGN_IN_WITH_TOKEN,
  SIGN_OUT,
} from 'constants/redux-actions';
import { API_SIGN_IN, API_SIGN_IN_WITH_TOKEN, API_USER_SSO } from 'constants/api-paths';

const initClient = () => get('', '', {}, { skipAPI: true });

const signIn = ({ email, password, rememberMe, siteId }) =>
  post(SIGN_IN, API_SIGN_IN, { email, password, rememberMe, siteId });

const signInWithToken = (token) => post(SIGN_IN_WITH_TOKEN, API_SIGN_IN_WITH_TOKEN, { token });
const signInWithConnectedAuth = (provider, token) => post(SIGN_IN_WITH_TOKEN, API_USER_SSO, { provider, token });

const signOut = createAction(SIGN_OUT);

const showConfirmNavigationModal = createAction(SHOW_CONFIRM_NAVIGATION_MODAL);

const clearSubmitedSignedInSignal = createAction(CLEAR_SUBMITED_SIGNED_IN_SIGNAL);

const clearToken = createAction(CLEAR_AUTH_TOKEN);

const initializeUserToken = (token, { rememberMe } = {}) =>
  createAction(INITIALIZE_USER_TOKEN)({ data: { token, rememberMe } });

const refreshToken = createAction(REFRESH_AUTH_TOKEN);

const setMfaChallenge = createAction(SET_MFA_CHALLENGE);
const clearMfaChallenge = createAction(CLEAR_MFA_CHALLENGE);

const authActions = {
  initClient,
  signIn,
  signInWithToken,
  signOut,
  showConfirmNavigationModal,
  clearSubmitedSignedInSignal,
  clearToken,
  signInWithConnectedAuth,
  initializeUserToken,
  refreshToken,
  setMfaChallenge,
  clearMfaChallenge,
};

export default authActions;
